import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import config from '../../config';
import axios from 'axios';

import '../../css/SingleScreens/UserProfileEditScreen.css';

import { ValidatorUtils, StringUtils } from '../../utils';
import { UserActions, NavigationActions, ContextActions, PracticeActions } from '../../actions';
import { TitleBar, SingleScreenNavBar, Input, Button, Errors } from  '../../components'

class UserProfileEditScreen extends Component {

  constructor(props) {
    super(props);
    this.state = {
      first_name: '',
      last_name: '',
      email: '',
      confirm_email: '',
      validation: {},
    }
  }

  componentDidMount() {
    const user = this.props.user && this.props.user.user ? this.props.user.user : null;
    if (user) {
      this.setState({
        photo_url: user.photo_url || '',
        first_name: user.first_name || '',
        last_name: user.last_name || '',
        email: user.email,
        confirm_email: user.email,
      });
    }
  }

  renderEditProfileSection = (user) => {
    if (!user) {
      return null;
    }

    const emailChanged = this.state.email !== user.email ? true : false;

    return <div className="flex-container screen-main-content">
      <div className="screen-container-column">
        <div className="basic-container">
          <div className="flex-container flex-container-column flex-center-align" style={{ marginBottom: 10 }}>
            { this.state.photo_url ? <img className="user-profile-edit-image" alt='User Profile Image to Edit or Change' src={this.state.photo_url} />
            : <span className="fas fa-user-circle" style={{ fontSize: 100, color: '#e9e9e9' }}></span> }
            <input  className="user-profile-pic-file-upload-input"
                    type='file'
                    id="file-upload"
                    onChange={ (event) => { this.handleFileUpload(event) }}
                  />
            <label className="button-clear-blue" style={{ marginTop: 5 }} htmlFor="file-upload">{ this.state.photo_url ? 'Edit Profile Pic' : 'Add Profile Pic' }</label>
          </div>
          <div className="flex-container flex-container-row flex-center-justify">
            <Input  value={StringUtils.sentenceCase(this.state.first_name)}
                    placeholder="First Name"
                    style={{ marginBottom: 10, marginRight: 20 }}
                    invalid={this.state.validation.fields && this.state.validation.fields['first_name']}
                    onChange={ (event) => { this.setState({ ...this.state, first_name: event.target.value }) }}
                  />
          </div>
          <div className="flex-container flex-container-row flex-center-justify">
            <Input  value={StringUtils.sentenceCase(this.state.last_name)}
                    placeholder="Last Name"
                    style={{ marginBottom: 10, marginRight: 20 }}
                    invalid={this.state.validation.fields && this.state.validation.fields['last_name']}
                    onChange={ (event) => { this.setState({ ...this.state, last_name: event.target.value }) }}
                  />
          </div>

          <div className="flex-container flex-container-row flex-center-justify">
            <Input  value={this.state.email}
                    placeholder="Email"
                    style={{ marginBottom: 10, marginRight: 20 }}
                    invalid={this.state.validation.fields && this.state.validation.fields['email']}
                    onChange={ (event) => { this.setState({ ...this.state, email: event.target.value }) }}
                  />
            { emailChanged
              ? <Input  value={this.state.confirm_email}
                        placeholder="Confirm Email"
                        style={{ marginBottom: 10 }}
                        invalid={this.state.validation.fields && this.state.validation.fields['confirm_email']}
                        onChange={ (event) => { this.setState({ ...this.state, confirm_email: event.target.value }) }}
                    />
              : null }
          </div>

          <Errors validation={this.state.validation} />
          <div className="flex-container flex-center-justify" style={{ marginTop: 20 }}>
            <Button value="Save"
                    style={{ marginRight: 5 }}
                    loading={this.props.loading && this.props.loading.userProfileEdit}
                    onClick={ () => {
                      this.saveProfileChanges(user)
                    }}
                  />
            <input  type="submit"
                    value="Cancel"
                    className="button-clear"
                    onClick={ () => {
                      NavigationActions.navigateBack()
                    }}
                  />
          </div>

        </div>
      </div>
    </div>
  }

  render() {
    const user = this.props.user && this.props.user.user ? this.props.user.user : null;
    return (
      <div className="flex-container flex-container-column flex-center-align">
        <TitleBar
          selectedPractice={this.props.context.selectedPractice}
          selectedRole={this.props.context.selectedRole}
          practices={this.props.user.practices}
          userActions={this.props.userActions}
          practice={this.props.practice.practice}
        />
        <SingleScreenNavBar title="Edit User Profile" />
        { this.renderEditProfileSection(user) }
      </div>
    );
  }

  handleFileUpload = (event) => {
    var file = event.target.files[0];
    var files = event.target.files;

    var mediaType = '';

    if (file && file.type === 'image/png') {
      mediaType = 'IMAGE'
    }

    if (file && file.type === 'video/mp4') {
      mediaType = 'VIDEO'
    }

    var reader = new FileReader();
    reader.onloadend = () => {

      const formData = new FormData();
      formData.append('file', files[0]);

      const requestURL = `${config.BASE_URL}/api/file/profile`;
      const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': this.props.user.auth.token } }

      axios.post(requestURL, formData, requestConfig).then((response) => {
        const data = response.data || {};
        if (data.success) {
          const url = data.message.Location;
          this.setState({ ...this.state, photo_url: url });
        }
      }).catch((error) => { console.log(error) });
    }

    reader.readAsDataURL(file);
  }

  saveProfileChanges = (user) => {
    const token = this.props.user.auth.token;
    var updatedUserObject = Object.assign({}, user);
    delete updatedUserObject.password;

    updatedUserObject.first_name = this.state.first_name;
    updatedUserObject.last_name = this.state.last_name;
    updatedUserObject.email = this.state.email;

    if (this.state.photo_url !== '') {
      updatedUserObject.photo_url = this.state.photo_url;
    }

    var validationObject = Object.assign({}, updatedUserObject);
    validationObject['confirm_email'] = this.state.confirm_email;
    const validation = ValidatorUtils.validate('userProfileEdit', validationObject);

    if (!validation.valid) {
      this.setState({ ...this.state, validation: validation });
      return;
    } else {
      this.setState({ ...this.state, validation: validation, loading: true });
    }

    this.props.userActions.editUser(token, updatedUserObject, this.callBack);
  }

  callBack = (error) => {
    if (error) {
      this.updateErrorMessage(error);
    } else {
      NavigationActions.navigateBack();
    }
  }

  updateErrorMessage = (errorMessage) => {
    const validation = {
      errors: [errorMessage],
    }
    this.setState({ ...this.state, validation: validation });
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    context: state.context,
    loading: state.loading,
    practice: state.practice,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    contextActions: bindActionCreators(
     { ...ContextActions }, dispatch),
    practiceActions: bindActionCreators(
     { ...PracticeActions }, dispatch),
    userActions: bindActionCreators(
     { ...UserActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UserProfileEditScreen)
